import { taskDefinitions } from "./tasks";
/** Automatic child workflow; not offered as a source-wide manual/scheduled run. */
export const GITHUB_EMAIL_WORKFLOW = "github.enrich_email";
export const GITHUB_EMAIL_TASK = taskDefinitions.enrich_email.name;
export const githubEmailWorkflow = {
  key: GITHUB_EMAIL_WORKFLOW,
  name: "GitHub · Enrich person email",
  tasks: [taskDefinitions.enrich_email],
} as const;
